import React from 'react';
import PillButton from 'components/atoms/Buttons/PillButton';
import './style.css';

const Page404: React.FC = () => (
  <div className="container">
    <h1>404</h1>
    <p>Page not found</p>
    {/* <PillButton variant="contained" color="primary">Go home</PillButton> */}
  </div>
);

export default Page404;
